import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import logo from '../assets/logo512.png';
import signature from '../assets/signature.png';
import html2pdf from 'html2pdf.js';

const PrescriptionPrint = () => {
  const { patientId } = useParams();
  const { token, user } = useAuth();
  const [records, setRecords] = useState([]);
  const printRef = useRef();

  useEffect(() => {
    axios.get(`${API_PATH}/medicalrecords/patients/${patientId}/records`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(res => setRecords(res.data || []))
    .catch(err => console.error('Error loading prescription:', err));
  }, [patientId, token]);

  const handleDownloadPDF = () => {
    const element = printRef.current;
    const opt = {
      margin: 0.5,
      filename: `Prescription_Patient_${patientId}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
    };
    html2pdf().set(opt).from(element).save();
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <button onClick={handleDownloadPDF} className="btn btn-primary m-2">Download PDF</button>

      <div ref={printRef} id="print-area" style={{ fontFamily: 'Arial, sans-serif', background: '#fff', padding: '20px' }}>
        {records.length > 0 && (() => {
          const record = records[records.length - 1];

          return (
            <div
              className="prescription-page"
              style={{
                maxWidth: '1123px',
                margin: '20px auto',
                padding: '20px',
                border: '1px solid #ccc',
                pageBreakInside: 'avoid',
                printColorAdjust: 'exact',
                WebkitPrintColorAdjust: 'exact',
              }}
            >
              {/* Header */}
              <div style={{
                backgroundColor: '#007BFF',
                color: '#fff',
                textAlign: 'center',
                padding: '10px 0',
                marginBottom: '20px',
              }}>
                <img src={logo} alt="Clinic Logo" style={{ height: '50px', marginBottom: '10px' }} />
                <h4 style={{ margin: 0 }}>Dr. {user?.fullName || 'Doctor'}</h4>
                <p style={{ margin: 0, fontSize: '14px' }}>Qualification: MBBS, MD</p>
              </div>

              {/* Patient Info */}
              <table style={{ width: '100%', fontSize: '14px', marginBottom: '20px' }}>
                <tbody>
                  <tr>
                    <td><strong>Patient Name:</strong> {record.patientName || 'N/A'}</td>
                    <td><strong>Contact:</strong> {record.patientContact || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Gender:</strong> {record.gender || 'N/A'}</td>
                    <td><strong>DOB:</strong> {record.dateOfBirth || 'N/A'}</td>
                  </tr>
                  <tr>
                    <td><strong>Date:</strong> {record.recordDate}</td>
                    <td><strong>Diagnosis:</strong> {record.diagnosis}</td>
                  </tr>
                </tbody>
              </table>

              {/* Prescriptions */}
              <h4 style={{ borderBottom: '1px solid #ccc' }}>Prescribed Medicines</h4>
              <table width="100%" border="1" cellPadding="6" style={{ borderCollapse: 'collapse', fontSize: '13px', marginBottom: '20px' }}>
                <thead style={{ backgroundColor: '#e9ecef' }}>
                  <tr>
                    <th>Medicine</th>
                    <th>Duration</th>
                    <th>Quantity</th>
                    <th>Dosage</th>
                  </tr>
                </thead>
                <tbody>
                  {record.prescriptions.map((p, index) => (
                    <tr key={index}>
                      <td>{p.medicineName}</td>
                      <td>{p.durationInDays} days</td>
                      <td>{p.totalQuantity}</td>
                      <td>
                        <ul style={{ paddingLeft: '20px', margin: 0 }}>
                          {p.dosage.map((dose, dIndex) => (
                            <li key={dIndex}>{dose.quantity} - {dose.timing} ({dose.relativeToMeal.replace('_', ' ')})</li>
                          ))}
                        </ul>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Tests */}
              {record.recommendedTests?.length > 0 && (
                <>
                  <h4 style={{ borderBottom: '1px solid #ccc' }}>Recommended Tests</h4>
                  <table width="100%" border="1" cellPadding="6" style={{ borderCollapse: 'collapse', fontSize: '13px', marginBottom: '20px' }}>
                    <thead style={{ backgroundColor: '#e9ecef' }}>
                      <tr>
                        <th>Test Name</th>
                        <th>Description</th>
                        <th>Notes</th>
                      </tr>
                    </thead>
                    <tbody>
                      {record.recommendedTests.map((test, tIndex) => (
                        <tr key={tIndex}>
                          <td>{test.testName}</td>
                          <td>{test.testDescription}</td>
                          <td>{test.notes}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              )}

              {/* Footer with signature */}
              <div style={{
                backgroundColor: '#007BFF',
                color: '#fff',
                textAlign: 'center',
                padding: '10px 0',
                marginTop: '30px',
              }}>
                <p><img src={signature} alt="Signature" style={{ height: '40px', marginBottom: '5px' }} /></p>
                <p style={{ margin: 0, fontSize: '12px' }}>
                  Clinic Name | 📍 24 Dummy Street Area | ☎️ +12-345-678-9012
                </p>
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default PrescriptionPrint;
